import { Store } from 'vuex';
import { Route, NavigationGuardNext } from 'vue-router';
import { PortalAppMode } from '../../services/Auth/types';
import indexOf from 'lodash/indexOf';
import { Dialog } from '../../store/modules';

/* eslint-disable-next-line */
export default function appModeCheck(store: Store<any>, bypassPerm = 'portalAppManager.override') {
	
	return (to: Route, from: Route, next: NavigationGuardNext ): void => {
		store.dispatch('auth/refreshMaintenanceMode', store)
			.then(() => {
				// todo: figure out what to do with modes
				if (store.state.auth.userStatus == 'loaded'
					&& indexOf([PortalAppMode.NOT_IMPLEMENTED, PortalAppMode.NOMINAL], store.state.auth.portalAppStatus) == -1) {
					let blocker = new Dialog(
						'Maintenance Mode',
						'This application is currently in maintenance mode. Sorry for the inconvenience. Check back soon.',
						'');
					blocker.setDismissable(false);

					if (store.state.auth.authManager.isRoot() || store.state.auth.authManager.canRead(bypassPerm)) {
						blocker = new Dialog(
							'Maintenance Mode',
							`This application is currently in maintenance mode. 
							Any write actions may cause problems. Use at your own risk.`,
							'Proceed'
						);
						blocker.setDismissable(false);
					}
					store.dispatch('notices/add', blocker);
				}
			})
			.catch(() => ({})); 
		next();
	};
}